import { IModelRaw } from './base';

export enum EPartnerType {
  Investor = 'investor',
  Youth = 'youth',
  Community = 'community',
}

export interface IPartner extends IModelRaw {
  name: string;

  logo: string | null;

  type: EPartnerType;

  priority: number;

  link_en?: string;

  link_vi?: string;
}
